import 'promise-polyfill/src/polyfill';
import { Dataviz, Dataset } from './index';

module.exports = {
  default: Dataviz,
  Dataviz,
  Dataset,
};
